export default "__VITE_ASSET__6428e10e__"